import isEmpty from 'lodash/isEmpty';
import urlParse from 'url-parse';
import type { OldGICPayload } from '../types.tsx';

export const extractEventAttributes = (trigger: HTMLElement): OldGICPayload => {
	const anchor = trigger.nodeName === 'A' ? trigger : trigger.querySelector('a');

	if (anchor) {
		const href = anchor.getAttribute('href');
		// @ts-expect-error - TS2769 - No overload matches this call. | TS7006 - Parameter 'qs' implicitly has an 'any' type.
		const { query } = urlParse(href, (qs) => new URLSearchParams(qs));
		const returnData = { prefilledFields: {} };
		// If data attributes exist, we will prefer those over the query params.
		// @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
		const pid = anchor.getAttribute('data-pid') || query.get('pid');
		// @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
		const issuetype = anchor.getAttribute('data-issue-type') || query.get('issuetype');
		// @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
		const requestype = anchor.getAttribute('data-itsm-category') || query.get('itsmCategory');

		if (pid) {
			// @ts-expect-error - TS2339 - Property 'pid' does not exist on type '{}'.
			returnData.prefilledFields.pid = pid;
		}
		if (issuetype) {
			// @ts-expect-error - TS2339 - Property 'issuetype' does not exist on type '{}'.
			returnData.prefilledFields.issuetype = issuetype;
		}
		if (requestype) {
			// @ts-expect-error - TS2339 - Property 'requestype' does not exist on type '{}'.
			returnData.prefilledFields.requestype = requestype;
		}
		if (!isEmpty(returnData.prefilledFields)) {
			return returnData;
		}
		return {};
	}

	return {};
};
